/* eslint-disable no-undef */
import { Controller } from 'stimulus';
import { featureEnabled } from 'lib/helpers';

export default class AdsController extends Controller {
  connect() {
    window.addEventListener('turbolinks:load', this.turbolinksInitAds);
    window.addEventListener('turbolinks:before-visit', this.resetAds);
  }

  disconnect() {
    window.removeEventListener('turbolinks:load', this.turbolinksInitAds);
    window.removeEventListener('turbolinks:before-visit', this.resetAds);
  }

  turbolinksInitAds = () => {
    this.adsScriptLoaded = false;

    this.initAds();
  }

  initAds = () => {
    if (featureEnabled('proper-ads')) {
      const properAdsScriptCheck = setInterval(() => {
        if (this.properSpaNewPageReady && !this.adsScriptLoaded) {
          properSpaNewPage(); /* eslint-disable-line no-undef */

          this.adsScriptLoaded = true;
        }

        if (this.properSpaNewPageReady) {
          clearInterval(properAdsScriptCheck);
        }
      }, 100);
    } else {
      const tmsAdScriptCheck = setInterval(() => {
        if (this.tmsAdsReady && !this.adsScriptLoaded) {
          window.TMSAds.setLayout(document.body.dataset.adLayout);

          this.adsScriptLoaded = true;
        }

        if (this.tmsAdsReady) {
          clearInterval(tmsAdScriptCheck);
        }
      }, 100);
    }
  }

  get properSpaNewPageReady() {
    if (typeof window.properSpaNewPage === 'undefined') return false;

    return true;
  }

  get tmsAdsReady() {
    if (typeof window.TMSAds === 'undefined') return false;
    if (typeof window.TMSAds.setLayout === 'undefined') return false;

    return true;
  }

  resetAds = () => {
    this.disconnect();

    this.connect();
  }
}
/* eslint-enable no-undef */
